import React, { Fragment } from "react";
import { Card, CardBody, Col, Container, Row, Label, Input, Table } from 'reactstrap';
import BreadCrumb from '../components/Common/BreadCrumb';

import CardLoader from "../components/CardLoader";
import MySearchOption from "../components/MySearchOption";
import IdiInspectionDashboardList from '../components/IdiInspectionDashboardList';

import { useDispatch, useSelector } from "react-redux";
import * as idiInspectionDashboardActions from "../actions/IdiInspectionDashboardActions";

const IdiInspectionDashboardScreen  = (props) => {
    const dispatch = useDispatch();

    const loading = useSelector((state) => state.idiinspectiondashboard.loading);
    const search = useSelector((state) => state.idiinspectiondashboard.search);

    const draftList = useSelector((state) => state.idiinspectiondashboard.draftList);
    const pendingForInspectionList = useSelector((state) => state.idiinspectiondashboard.pendingForInspectionList);
    const inspectionInProcessList = useSelector((state) => state.idiinspectiondashboard.inspectionInProcessList);
    const readyForReviewList = useSelector((state) => state.idiinspectiondashboard.readyForReviewList);
    const uploadToTawuniyaList = useSelector((state) => state.idiinspectiondashboard.uploadToTawuniyaList);
    const completedList = useSelector((state) => state.idiinspectiondashboard.completedList);
    const closedList = useSelector((state) => state.idiinspectiondashboard.closedList);
    const abortedList = useSelector((state) => state.idiinspectiondashboard.abortedList);

    const searchList = useSelector((state) => state.idiinspectiondashboard.searchList);
  
    const user = useSelector((state) => state.login.user);

    const [fboSearch, setFBOSearch] = React.useState(search);

    const [showIdiInspectionDraft, setShowIdiInspectionDraft] = React.useState(user.showIdiInspectionDraft);
    const [showIdiInspectionPendingForInspection, setShowIdiInspectionPendingForInspection] = React.useState(user.showIdiInspectionPendingForInspection);
    const [showIdiInspectionInspectionInProcess, setShowIdiInspectionInspectionInProcess] = React.useState(user.showIdiInspectionInspectionInProcess);
    const [showIdiInspectionReadyForReview, setShowIdiInspectionReadyForReview] = React.useState(user.showIdiInspectionReadyForReview);
    const [showIdiInspectionUploadToTawuniya, setShowIdiInspectionUploadToTawuniya] = React.useState(user.showIdiInspectionUploadToTawuniya);
    const [showIdiInspectionCompleted, setShowIdiInspectionCompleted] = React.useState(user.showIdiInspectionCompleted);
    const [showIdiInspectionClosed, setShowIdiInspectionClosed] = React.useState(user.showIdiInspectionClosed);
    const [showIdiInspectionAborted, setShowIdiInspectionAborted] = React.useState(user.showIdiInspectionAborted);
   
    React.useEffect(() => {
		dispatch(idiInspectionDashboardActions.loadIdiInspectionDashboard("", fboSearch));
    }, []);

    React.useEffect(() => {
		setFBOSearch(search);
    }, [search]);

    const searchInspections = () => {
        dispatch(idiInspectionDashboardActions.loadIdiInspectionDashboard("", fboSearch));
        dispatch(idiInspectionDashboardActions.setIdiInspectionDashboardFilterSearch(fboSearch));
    }

    return(
        <Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col xs={12}>
                            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        <h4 className="mb-sm-0">INSPECTION LIST</h4>
                                    </div>
                                    <div className="flex-shrink-0">
                                        {!showIdiInspectionDraft && draftList.length > 0 && <span className="badge bg-idii-draft ms-2">DRAFT: {draftList.length}</span>}
                                        {!showIdiInspectionPendingForInspection && pendingForInspectionList.length > 0 && <span className="badge bg-idii-pending ms-2">PENDING: {pendingForInspectionList.length}</span>}
                                        {!showIdiInspectionInspectionInProcess && inspectionInProcessList.length > 0 && <span className="badge bg-idii-process ms-2">IN PROCESS: {inspectionInProcessList.length}</span>}
                                        {!showIdiInspectionReadyForReview && readyForReviewList.length > 0 && <span className="badge bg-idii-review ms-2">READY: {readyForReviewList.length}</span>}
                                        {!showIdiInspectionUploadToTawuniya && uploadToTawuniyaList.length > 0 && <span className="badge bg-idii-review ms-2">UPLOAD: {uploadToTawuniyaList.length}</span>}
                                        {!showIdiInspectionCompleted && completedList.length > 0 && <span className="badge bg-idii-completed ms-2">COMPLETE: {completedList.length}</span>}
                                        {!showIdiInspectionClosed && closedList.length > 0 && <span className="badge bg-idii-closed ms-2">CLOSE: {closedList.length}</span>}
                                        {!showIdiInspectionAborted && abortedList.length > 0 && <span className="badge bg-idii-aborted ms-2">ABORT: {abortedList.length}</span>}
                                    </div>
                                </div>
                                <div className="d-flex">
                                    <MySearchOption
                                        placeholder={"Search for Idi Inspections..."}
                                        value={fboSearch}
                                        searchList={searchList || []}
                                        fieldName=""
                                        onChange={setFBOSearch}
                                    />
                                    <button type="button" className="btn btn-primary btn-icon rounded-pill ms-1" title="Search Inspections"
                                        onClick={() => searchInspections()}
                                    >
                                        <i className="ri-search-line" />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        <div className="tasks-board mb-3" id="kanbanboard">
                            <CardLoader loading={loading} />
                            {showIdiInspectionDraft && <IdiInspectionDashboardList title="Draft" titleClass="bg-idii-draft" borderClass="border-idii-draft" list={draftList}  />}
                            {showIdiInspectionPendingForInspection && <IdiInspectionDashboardList title="Pending for Inspection" titleClass="bg-idii-pending" borderClass="border-idii-pending" list={pendingForInspectionList}  />}
                            {showIdiInspectionInspectionInProcess && <IdiInspectionDashboardList title="Inspection In Process" titleClass="bg-idii-process" borderClass="border-idii-process" list={inspectionInProcessList}  />}
                            {showIdiInspectionReadyForReview && <IdiInspectionDashboardList title="Ready for Review" titleClass="bg-idii-review" borderClass="border-idii-review" list={readyForReviewList}  />}
                            {showIdiInspectionUploadToTawuniya && <IdiInspectionDashboardList title="Upload To Tawuniya" titleClass="bg-idii-review" borderClass="border-idii-review" list={uploadToTawuniyaList}  />}
                            {showIdiInspectionCompleted && <IdiInspectionDashboardList title="Completed (Pending Invoice)" titleClass="bg-idii-completed" borderClass="border-idii-completed" list={completedList}  />}
                            {showIdiInspectionClosed && <IdiInspectionDashboardList title="Closed" titleClass="bg-idii-closed" borderClass="border-idii-closed" list={closedList}  />}
                            {showIdiInspectionAborted && <IdiInspectionDashboardList title="Aborted" titleClass="bg-idii-aborted" borderClass="border-idii-aborted" list={abortedList}  />}
                        </div>
                    </Row>                
                </Container>
            </div>
        </Fragment>
    );
}

export default IdiInspectionDashboardScreen;